import { Box, Button } from '@synergy-marine-group/synergy-ui';
import React from 'react';
import EditIcon from '../../images/icons/edit_icon.svg';
import { returnPolicies } from '../../PermissionUtility/ProfilePolicies';

const Footer = ({ isLoading, isduplicateloading, page, dataFail, isCrewPage,
  handleCancel, isdraftButton, setDraft, handleSendPO, mode, showAdd = true, handleEdit,
  isAgencyPage = false, isAgencyPoEditable = true }) => {
    const policies = returnPolicies();

    const handleDraft = () => {
    if (setDraft) {
      setDraft(false);
    }
  };
  const handleDraftEdit = () => {
    if (mode === 'add') {
      handleDraft();
    } else {
      setDraft(true);
    }
  };
  return (
    <Box
      className=" fixed bottom bg-white"
      style={{
        width: '100%',
        left: 0,
        right: 0,
        bottom: 0,
        positon: 'sticky' }}
      variant={2}
    >
      <div className="flex justify-end gap-4 pb-4">
        <Button type="button" className="" onClick={handleCancel} rounded size="medium" variant="outlined">
          Cancel
        </Button>
        {isdraftButton
  && mode === 'add'
  && (isCrewPage ? policies?.poPolicies?.canEdit : policies?.VesselpoPolicies?.canEdit) && (
          <Button
            form="my-form"
            type="submit"
            className=""
            onClick={() => setDraft(true)}
            rounded
            size="medium"
            variant="outlined"
            disabled={isLoading || isduplicateloading}
          >
            Save as Draft
          </Button>
        )}

        {handleSendPO ? (
          <Button
            type="button"
            className="text-black"
            hidden={
              isCrewPage
                ? !policies?.poPolicies?.canEdit
                : !policies?.VesselpoPolicies?.canEdit
            }
            rounded
            size="medium"
            variant="filled"
            disabled={isLoading || isduplicateloading || dataFail}
            onClick={handleSendPO}
          >
            Send PO
          </Button>
        ) : showAdd ? (
          <Button
            form="my-form"
            type="submit"
            className="text-black"
            rounded
            size="medium"
            variant="filled"
            hidden={
              page === 'vendorMapping'
                ? !policies?.vendorPolicies?.canEdit
                : isCrewPage
                  ? !policies?.poPolicies?.canEdit
                  : !policies?.VesselpoPolicies?.canEdit
            }
            disabled={isLoading || isduplicateloading || dataFail}
            onClick={handleDraftEdit}
          >
            {mode === 'add' ? 'Send PO' : 'Save'}
          </Button>
        ) : (
          ''
        )}
        {handleEdit
        && (isCrewPage ? policies?.poPolicies?.canEdit : policies?.VesselpoPolicies?.canEdit)
        && !(isAgencyPage === true && !policies?.agencyPoPolicies?.canEdit) && (
          <Button
            type="button"
            className="mr-2"
            onClick={handleEdit}
            rounded
            size="medium"
            variant="filled"
            hidden={dataFail}
            disabled={isAgencyPage && isAgencyPoEditable === false}
          >
            <div className="flex">
              <img src={EditIcon} alt="EditIcon" />
              <div className="ml-2">Edit</div>
            </div>
          </Button>
        )}
        {mode === 'edit' && (
          <Button
            form="my-form"
            type="submit"
            className="text-black"
            rounded
            size="medium"
            variant="filled"
            hidden={
              isCrewPage
                ? !policies?.poPolicies?.canEdit
                : !policies?.VesselpoPolicies?.canEdit
            }
            disabled={isLoading || isduplicateloading || dataFail}
            onClick={() => setDraft(false)}
          >
            Send PO
          </Button>
        )}
      </div>
    </Box>
  );
};

export default Footer;
